import { IErknmFormAgreement } from 'KnmErknmPackage/MainModule/interfaces/IErknmFormAgreement';
import { AgreementStatusEnum } from 'APIPackage/KnmModule/enums/AgreementStatusEnum';

import styles from './AgreementHeaderStatus.module.scss';

interface IAgreementHeaderStatusProps {
  agreement: IErknmFormAgreement;
}

const statusesMap = {
  [AgreementStatusEnum.DRAFT]: {
    title: 'Черновик',
    className: styles.blue,
  },
  [AgreementStatusEnum.CANCELED]: {
    title: 'Отказано',
    className: styles.red,
  },
  [AgreementStatusEnum.READY_TO_APPROVE]: {
    title: 'Готово к согласованию',
    className: styles.blue,
  },
  [AgreementStatusEnum.ON_APPROVAL]: {
    title: 'На согласовании',
    className: styles.yellow,
  },
  [AgreementStatusEnum.DENIED]: {
    title: 'Не согласовано',
    className: styles.red,
  },
  [AgreementStatusEnum.APPROVED]: {
    title: 'Утверждено',
    className: styles.green,
  },
  [AgreementStatusEnum.TERMINATED]: {
    title: 'Расторгнуто',
    className: styles.red,
  },
  [AgreementStatusEnum.COMPLETED]: {
    title: 'Исполнено',
    className: styles.green,
  },
  [AgreementStatusEnum.NOT_COMPLETED]: {
    title: 'Не исполнено',
    className: styles.red,
  },
  [AgreementStatusEnum.PENDING_TERMINATION]: {
    title: 'Не исполнено. Ожидает расторжения',
    className: styles.red,
  },
};

export const AgreementHeaderStatus = ({ agreement }: IAgreementHeaderStatusProps) => {
  if (!agreement.status) return null;

  const status = statusesMap[agreement.status];

  return <div className={status.className}>{status.title}</div>;
};
